import { render, staticRenderFns } from "./tagSpreading.vue?vue&type=template&id=4703971e&"
import script from "./tagSpreading.vue?vue&type=script&lang=js&"
export * from "./tagSpreading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports